import type { ChangeValueDto, CustomerAuditLogDto } from './customers/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomerAuditLogService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getLogs = (entityId: string, entityType: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CustomerAuditLogDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/customer-audit-log/logs/${entityId}`,
      params: { entityType },
    },
    { apiName: this.apiName,...config });
  

  logChanges = (entityId: string, entityType: string, actionType: string, changes: Record<string, ChangeValueDto>, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/customer-audit-log/log-changes/${entityId}`,
      params: { entityType, actionType },
      body: changes,
    },
    { apiName: this.apiName,...config });
}